<template>
  <pl-dialog
    :header="'Create New School'"
    :headerStyle="'font-size: 24px; font-weight: bold'"
    :width="'600px'"
    :padding="'2em'"
  >
    <pl-input
      v-model="school_name"
      :labelText="'School name'"
      :placeholder="'add school name'"
    />
    <div class="row mt3 center-xs">
      <pl-button @click.native="$emit('close')"> CANCEL </pl-button>
      <pl-button
        class="pl-primary"
        @click.native="createNewSchool"
        :disabled="!school_name"
      >
        CREATE SCHOOL
      </pl-button>
    </div>
  </pl-dialog>
</template>
<script>
  import { EventBus } from 'utils/event-bus';
  import adminServices from 'services/admin/adminServices';
  export default {
    data() {
      return {
        school_name: '',
      };
    },
    methods: {
      createNewSchool() {
        adminServices
          .createSchool()
          .then((res) => {
            adminServices
              .editSchool(res.data.id, { name: this.school_name })
              .then(({ data }) => {
                this.alertToast('Success')();
                this.$emit('close');
                this.$store.dispatch('updateSchoolDetails', data);
                this.$router.push(`/admin-portal/${res.data.id}/schoolInfo`);
              })
              .catch(() => {
                this.alertToast('Failure');
                this.$emit('close');
              });
          })
          .catch((err) => console.error(err));
      },
      alertToast(msg) {
        return () => {
          EventBus.$emit('toast-msg', msg);
        };
      },
    },
  };
</script>
<style lang="stylus" scoped></style>



// WEBPACK FOOTER //
// editSchoolModal.vue?276ca83f